import * as React from "react"

import { cn } from "../../lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      data-ui="input"
      // Token-first surface — follows the active theme. See input.tsx.
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-[hsl(var(--border-input,var(--input)))] bg-[hsl(var(--input-bg,var(--background)))] text-foreground px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
